<template>
  <pagelayout :contentBgcolor="isDark && '#eeeeee'">
    <appbar :title="`PCDD${app_my_config.lotteryCredit.name}说明`" />
    <div class="guide">
      <div class="tit">特码</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">特码</td>
            <td>
              开奖结果三位数的总{{ app_my_config.lotteryTotal.name }}与投注数字相同时，即为中奖，其余情形视为未中奖。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">特码包三</td>
            <td>
              从0-27共28个号码中选择3个不重复的号码组成1注，所选号码包含当期所有3个开奖号码{{
                app_my_config.lotteryTotal.name
              }}（0-27），视为中奖，其余情形视为未中奖。
            </td>
          </tr>
        </tbody>
      </table>

      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">
              混合
              <br />
              大小
            </td>
            <td>
              当期所有3个开奖号码总{{
                app_my_config.lotteryTotal.name
              }}（0-27）大小，0-13为小，14-27为大。若投注内容符合当期开奖结果，视为中奖，其余情形视为未中奖。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">
              混合
              <br />
              单双
            </td>
            <td>
              当期所有3个开奖号码总{{
                app_my_config.lotteryTotal.name
              }}（0-27）是为单数或双数，1、3、5、……23、25、27为单，0、2、4、……22、24、26为双。若投注内容符合当期开奖结果，视为中奖，其余情形视为未中奖。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">
              混合
              <br />
              大小单双
            </td>
            <td>
              当期所有3个开奖号码总{{
                app_my_config.lotteryTotal.name
              }}（0-27）大小与单双，0-13为小，14-27为大，1、3、5、……23、25、27为单，0、2、4、……22、24、26为双。若投注内容符合当期开奖结果，视为中奖，其余情形视为未中奖。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">
              混合
              <br />
              极大
            </td>
            <td>
              当期所有3个开奖号码总{{ app_my_config.lotteryTotal.name }}为 22、23、24、25、26、27
              中的一个数值时，则投注极大会中奖。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">
              混合
              <br />
              极小
            </td>
            <td>
              当期所有3个开奖号码总{{ app_my_config.lotteryTotal.name }}为 0、1、2、3、4、5
              中的一个数值时，则投注极小会中奖。
            </td>
          </tr>
        </tbody>
      </table>

      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">波色</td>
            <td>
              当期所有3个开奖号码总{{
                app_my_config.lotteryTotal.name
              }}（0-27）所属色波。若投注内容符合当期开奖结果，视为中奖，其余情形视为未中奖。
              <br />
              红波：3、6、9、12、15、18、21、24。
              <br />
              蓝波：2、5、8、11、17、20、23、26。
              <br />
              绿波：1、4、7、10、16、19、22、25。
              <br />
              开出灰色号码：0、13、14、27通吃 【红波】、【蓝波】、【绿波】各注。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">豹子</td>
            <td>当期开奖号码的三个数字都相同时，则投注豹子会中奖。</td>
          </tr>
        </tbody>
      </table>
    </div>
  </pagelayout>
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
export default {
  mixins: [appConfigMixins]
}
</script>

<style lang="scss">
@import '~/assets/common/page/guide.scss';
</style>
